import {
  add,
  list,
  del,
  update,
  getBoxData,
  getDataReport,
  addBoxInfo,
  getBoxInfo,
  updateProjectPosition,
} from '@/api/project';
import store from '@/store';
export default {
  namespaced: true,
  state: {
    projectList: [],
    projectTotal: 0,
    theme: localStorage.getItem('useDarkKEY') || '',
    chooseProject:
      JSON.parse(localStorage.getItem('VUE_APP_PROJECT_CHOOSE')) || {},
  },
  getters: {},
  mutations: {
    // 设置主题
    changeTheme(state, data) {
      state.theme = data === true ? 'auto' : 'dark';
    },
    // 设置项目列表
    projectList(state, data) {
      state.projectList = data;
    },
    // 设置当前选中项目
    setProject(state, data) {
      state.chooseProject = data;
      localStorage.setItem('VUE_APP_PROJECT_CHOOSE', JSON.stringify(data));
      // 设置用户信息
      const projectData = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      );
      projectData.project_id = data.PROJECT_ID;
      projectData.project_type = data.TYPE;
      store.commit('user/updateUserInfo', projectData);
      // localStorage.setItem(
      //   "VUE_MW_ADMIN_USER_INFO",
      //   JSON.stringify(projectData)
      // );
    },
    // 设置项目网关信息
    boxInfo(state, data) {
      state.chooseProject.boxInfo = data;
      localStorage.setItem(
        'VUE_APP_PROJECT_CHOOSE',
        JSON.stringify(state.chooseProject)
      );
    },
  },
  actions: {
    // 添加项目
    async addProject(_context, data) {
      // 获取用户id
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      if (userId !== null) {
        data.user_id = userId;
        try {
          const res = add(data);
          return res;
        } catch (err) {
          return Promise.reject(err);
        }
      }
      return Promise.reject('用户id不存在');
    },
    // 获取项目列表
    async getProjectList({ commit }) {
      // 获取用户id
      if (localStorage.getItem(process.env.VUE_APP_USER_INFO)) {
        const data = {
          user_id: JSON.parse(
            localStorage.getItem(process.env.VUE_APP_USER_INFO)
          ).id,
        };
        if (data.user_id !== null) {
          try {
            const res = await list(data);
            if (res && res.code === 0) {
              commit('projectList', res.data.list);
              // 设置当前选中项目
              // 原写法是 `chooseProject != {}`：新建的对象字面量永不等于任何已有值，
              // 这个守卫恒为真（被 no-constant-binary-expression 逮到）。本意显然是
              // "当前有选中项目"，故改为真值判断——state 初值 `JSON.parse(...) || {}`
              // 保证它恒为对象，对所有可达取值结果与原来一致。
              if (store.state.project.chooseProject) {
                for (let i = 0; i < res.data.list.length; i++) {
                  if (
                    res.data.list[i].PROJECT_ID ===
                    store.state.project.chooseProject.PROJECT_ID
                  ) {
                    commit('setProject', res.data.list[i]);
                  }
                }
              }
            }
            return res.message;
          } catch (err) {
            return Promise.reject(err);
          }
        }
      }
      store.commit('user/logout');
      return Promise.reject('用户id不存在');
    },
    // 删除项目
    async delProject(_context, data) {
      try {
        const res = await del(data);
        return res;
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 修改项目
    async updateProject(_context, data) {
      // 获取用户id
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      try {
        data.user_id = userId;
        const res = await update(data);
        // 获取项目
        return res;
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 获取盒子数据
    async getBoxData(_context, data) {
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      try {
        data.user_id = userId;
        const res = await getBoxData(data);
        return res;
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 获取报表数据
    async getDataReport(_context, data) {
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      try {
        data.user_id = userId;
        const res = await getDataReport(data);
        return res;
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 添加项目网关信息
    async addProjectBoxInfo(_context, data) {
      // 获取用户id
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      try {
        data.user_id = userId;
        const res = await addBoxInfo(data);
        return res;
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 获取项目网关信息
    async getBoxInfo({ commit }, data) {
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      try {
        data.user_id = userId;
        const res = await getBoxInfo(data);
        if (res && res.code === 0) {
          commit('boxInfo', res.data.boxInfo);
        }
        return res.message;
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 修改项目位置信息
    async updateProjectPosition(_context, data) {
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      try {
        data.user_id = userId;
        const res = await updateProjectPosition(data);
        if (res && res.code === 0) {
          // 获取项目列表
          store.dispatch('project/getProjectList');
        }
        return res;
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};

